import React, {useContext, lazy, Suspense} from "react";
import {useLocation} from 'react-router-dom';
import AppContext from '../../shared/components/AppContext';
import Menu from "../../shared/components/Menu";
import { ProgressSpinner } from 'primereact/progressspinner'; 
import { BlockUI } from 'primereact/blockui';
import {useTranslation} from "react-i18next"
import {Helmet} from "react-helmet-async";


import "./Surveys.scss";
import "../../../styles/Menu.scss";

const HeaderComponent = lazy(() => import('../../shared/components/HeaderComponent'));
const SurveyListRespondent = lazy(() => import('../../shared/components/SurveyListRespondent'));
const SurveyListClient = lazy(() => import('../../shared/components/SurveyListClient'));
const NewSurvey = lazy(() => import('../../shared/components/Survey/NewSurvey'));
const EditSurvey = lazy(() => import('../../shared/components/Survey/EditSurvey'));
const ProfileInfo = lazy(() => import('../../shared/components/ProfileInfo'));

/**
 * It renders the Header, Menu, Footer, and either the NewSurvey, EditSurvey, SurveyListRespondent, or
 * SurveyListClient components. 
 * 
 * The Header, Menu, and Footer components are always rendered. 
 * 
 * The NewSurvey, EditSurvey, SurveyListRespondent, or SurveyListClient components are rendered based
 * on the URL. 
 * 
 * The NewSurvey and EditSurvey components are rendered when the URL contains the string "NewSurvey" or
 * "EditSurvey". 
 * 
 * The SurveyListRespondent or SurveyListClient components are rendered based on the user's role. 
 * 
 * The SurveyListRespondent component is rendered when the user's role is "Respondent". 
 * 
 * The SurveyListClient component is rendered when the user's role is not "Respondent".
 */
export default function Surveys() { 

  const myContext = useContext(AppContext); 
  const location = useLocation();
  const { t } = useTranslation();

  const showLocation = () => { 

    if (location.pathname.includes('NewSurvey')) {
      return <NewSurvey  isNewSurvey={true} />;
    } else if (location.pathname.includes('EditSurvey')) {
      return <EditSurvey isNewSurvey={false} />;
    } else if (location.pathname.includes('ProfileInfo')) {
      return <ProfileInfo />;
    } else if (myContext.user.role === "Respondent" ) {
      return <SurveyListRespondent/>;
    }else {
      return <SurveyListClient />;
    }

  }

  const renderLoader = () =>  <BlockUI blocked={true} fullScreen> <ProgressSpinner /> </BlockUI>;


  return ( 
    <Suspense fallback={renderLoader()}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("SEO.SURVEYS.TITLE")}</title>
        <meta name="description" content={t("SEO.SURVEYS.DESCRIPTION")} />
      </Helmet>
      <div className="">
        <HeaderComponent loginPage={false}></HeaderComponent>  
        <div className="main">
            <Menu Respondent={myContext.user.role === "Respondent" ? true : false}></Menu> 
            { showLocation() }
        </div>
      </div>
    </Suspense> 
  );
  
}
